import { render, staticRenderFns } from "./noSales.vue?vue&type=template&id=11815d94&scoped=true"
import script from "./noSales.vue?vue&type=script&lang=js"
export * from "./noSales.vue?vue&type=script&lang=js"
import style0 from "./noSales.vue?vue&type=style&index=0&id=11815d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11815d94",
  null
  
)

export default component.exports